import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  IconButton,
  TextField,
  Button,
} from "@mui/material";
import cancel from "../../../assets/images/cancel.svg";
import CloseIcon from "@mui/icons-material/Close";
import ChooseFile from "./ChooseFile";

type RejectDialogueBoxProps = {
  open: boolean;
  onClose: () => void;
  label: string;
  handleSubmission: any;
  getFiles: any;
  file: any;
  getReason: any;
  reason: string;
};

export default function RejectDialogueBox(props: RejectDialogueBoxProps) {
  const {
    open,
    onClose,
    label,
    handleSubmission,
    getFiles,
    file,
    getReason,
    reason,
  } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: "visible",
          position: "relative",
          boxShadow: 5,
          borderBottom: `6px solid #E8003F`,
          height: { xs: 550, sm: 570 },
          width: { xs: 350, sm: 450 },
        },
      }}
    >
      {/* Top Red Circle */}
      <Box
        sx={{
          position: "absolute",
          top: -60,
          left: "50%",
          transform: "translateX(-50%)",
          width: 125,
          height: 125,
          borderRadius: "50%",
          backgroundColor: "background.paper",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          boxShadow: "inset 0 0 12px rgba(0, 0, 0, 0.2)",
          zIndex: 1,
        }}
      >
        <img
          src={cancel}
          alt="Reject"
          style={{ height: 70, width: 70, objectFit: "contain" }}
        />
      </Box>

      {/* Close Button */}
      {/* <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          top: -4,
          right: -4,
          backgroundColor: "error.main",
          color: "#fff",
          "&:hover": {
            backgroundColor: "error.dark",
          },
          width: 30,
          height: 30,
          zIndex: 2,
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton> */}

      <DialogContent
        sx={{
          mt: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          px: 4,
        }}
      >
        {/* Title */}
        <Typography fontSize={34} fontWeight={600} color="#E8003F">
          {label}
        </Typography>

        {/* Reason Input */}
        <Box width="100%">
          <Typography variant="body1" fontWeight={600} fontSize={18} mb={1}>
            Reason
          </Typography>
          <TextField
            multiline
            rows={5}
            fullWidth
            variant="outlined"
            value={reason}
            onChange={(e) => getReason(e.target.value)}
          />
        </Box>

        {/* File Upload */}
        <Box width="100%">
          <Typography variant="body1" fontWeight={600} fontSize={18} mb={1}>
            Upload Repudiation Letter
          </Typography>
          <ChooseFile
            fileName={file?.name ?? "No file chosen"}
            onChange={(e) => {
              const selectedFile = e.target.files?.[0];
              getFiles(selectedFile);
            }}
          />
        </Box>

        {/* Upload Button */}
        <Box
          width="100%"
          display="flex"
          justifyContent="flex-start"
          gap={2}
          mt={1}
        >
          <Button
            variant="contained"
            sx={{
              width: 190,
              backgroundColor: "#E8003F",
              fontWeight: 600,
              fontSize: 16,
              borderRadius: "24px",
              "&:hover": {
                backgroundColor: "#c70036",
              },
            }}
            onClick={() => {
              handleSubmission("Decline");
              onClose();
            }}
          >
            Submit
          </Button>
          {/* Cancel Button */}
          <Button
            variant="outlined"
            sx={{
              width: 190,
              fontWeight: 600,
              fontSize: 16,
              borderRadius: "24px",
              borderColor: "#999",
              color: "white",
            }}
            onClick={onClose}
          >
            Cancel
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
